// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SummaryPage-module__overviewDetailsText___ZBiDa {
    margin-left: 10px;
    font-size: 1rem;
    color: #555;
    margin-top: 8px;
    word-break: break-word;
}

.SummaryPage-module__container___S4mpK {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: calc(100vh - 100px);
    padding: 30px;
    align-items: center;
    justify-content: center;
    margin: 0;
    overflow-x: hidden;
}

.SummaryPage-module__secondRow___e7aMi {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
}

.SummaryPage-module__column___j6QZx {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    flex: 1;
}

.SummaryPage-module__secondColumn___ovbt8 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px;
    position: relative;
    min-height: 100%;
}

.SummaryPage-module__secondColumnContainer___BdBpD {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    gap: 60px;
    animation: SummaryPage-module__fadeIn___FZxnH 0.3s ease-in-out;
}

.SummaryPage-module__panelColumn___mxzrR {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    position: relative;
    width: fit-content;
}

.SummaryPage-module__resultDoubleRow___xILDN {
    flex: 0 0 500px;
    display: flex;
    flex-direction: column;
    width: 500px;
    min-width: 500px;
}

.SummaryPage-module__progressRow___TBw23 {
    display: flex;
    flex-direction: column;
    width: 500px;
    position: relative;
    align-items: center;
}

.SummaryPage-module__resultDetails___uQOEU {
    margin-top: 53px;
    width: 500px;
}

.SummaryPage-module__miniaturePanelContainer___lXxPJ {
    position: absolute;
    bottom: -60px;
    right: 0;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    padding: 10px 0;
    z-index: 1;
    width: 100%;
}

.SummaryPage-module__extraText____XgcM {
    margin-top: 10px;
    text-align: center;
    padding: 0 20px;
    width: 100%;
}

.SummaryPage-module__small_adshel_image___bAYlQ,
.SummaryPage-module__small_spectacular_portrait_image___NYWPh,
.SummaryPage-module__small_escalator_image___H3FqB,
.SummaryPage-module__small_threegroup_image___JALWJ {
    height: 40px;
    width: 20px;
    margin: 5px;
    cursor: pointer;
    transition: transform 0.2s ease;
}

.SummaryPage-module__small_spectacular_image___n8ULD,
.SummaryPage-module__small_billboard_image___q8I59,
.SummaryPage-module__small_storm_image___lDtpJ {
    height: 20px;
    width: 40px;
    margin: 5px;
    cursor: pointer;
    transition: transform 0.2s ease;
}

    .SummaryPage-module__small_adshel_image___bAYlQ:hover,
    .SummaryPage-module__small_spectacular_portrait_image___NYWPh:hover,
    .SummaryPage-module__small_escalator_image___H3FqB:hover,
    .SummaryPage-module__small_threegroup_image___JALWJ:hover,
    .SummaryPage-module__small_spectacular_image___n8ULD:hover,
    .SummaryPage-module__small_billboard_image___q8I59:hover,
    .SummaryPage-module__small_storm_image___lDtpJ:hover {
        transform: scale(1.1);
    }

@keyframes SummaryPage-module__fadeIn___FZxnH {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

/* Responsive Breakpoints */
@media (max-width: 1420px) {
    .SummaryPage-module__secondColumnContainer___BdBpD {
        gap: 40px;
    }

    .SummaryPage-module__panelColumn___mxzrR {
        max-width: calc(100% - 540px); /* 500px for Details + 40px gap */
    }
}

@media (max-width: 1370px) {
    .SummaryPage-module__container___S4mpK {
        padding: 80px 20px 20px 20px;
        height: calc(100vh - 100px); /* Fixed height */
        overflow-y: auto;
        justify-content: flex-start; /* Change to flex-start since we're scrolling */
    }

    .SummaryPage-module__secondColumnContainer___BdBpD {
        flex-direction: column;
        gap: 30px;
        align-items: center;
        justify-content: flex-start;
        padding: 0;
        min-height: min-content; /* Allow container to be as small as its content */
    }

    .SummaryPage-module__secondColumn___ovbt8 {
        min-height: min-content; /* Allow column to be as small as its content */
    }

    .SummaryPage-module__resultDoubleRow___xILDN {
        order: -1;
        margin-bottom: 30px;
    }

    .SummaryPage-module__panelColumn___mxzrR {
        width: fit-content;
        max-width: calc(100% - 40px);
        margin-top: 0; /* Remove auto margin since we're controlling height */
        margin-bottom: 60px;
    }

    .SummaryPage-module__miniaturePanelContainer___lXxPJ {
        bottom: -60px;
        right: 50%;
        transform: translateX(50%);
    }
}

@media (max-width: 600px) {
    .SummaryPage-module__container___S4mpK {
        padding: 10px;
    }

    .SummaryPage-module__secondColumn___ovbt8 {
        padding: 5px;
    }

    .SummaryPage-module__resultDoubleRow___xILDN,
    .SummaryPage-module__progressRow___TBw23,
    .SummaryPage-module__resultDetails___uQOEU {
        max-width: 100%;
        overflow-x: auto;
    }

    .SummaryPage-module__secondColumnContainer___BdBpD {
        gap: 20px;
    }

    .SummaryPage-module__panelColumn___mxzrR {
        max-width: calc(100% - 20px);
    }
}

/* Table styles remain unchanged */
.SummaryPage-module__table___CIbbB {
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
}

    .SummaryPage-module__table___CIbbB td {
        padding: 6px 8px;
        text-align: left;
        vertical-align: middle;
        font-size: 14px;
        line-height: 1.4;
    }

.SummaryPage-module__boldText___ozG6r {
    font-weight: 600;
    min-width: 80px;
    color: #333;
    padding-right: 16px;
}

.SummaryPage-module__table___CIbbB tr:hover {
    background-color: rgba(0, 0, 0, 0.02);
}


@media (min-aspect-ratio: 2) {
    .SummaryPage-module__container___S4mpK {
        height: calc(100vh - 70px);
    }
}`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/SummaryPage/SummaryPage.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,OAAO;AACX;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,SAAS;IACT,8DAAkC;AACtC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,aAAa;IACb,yBAAyB;IACzB,SAAS;IACT,eAAe;IACf,UAAU;IACV,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;;AAEA;;;;IAII,YAAY;IACZ,WAAW;IACX,WAAW;IACX,eAAe;IACf,+BAA+B;AACnC;;AAEA;;;IAGI,YAAY;IACZ,WAAW;IACX,WAAW;IACX,eAAe;IACf,+BAA+B;AACnC;;IAEI;;;;;;;QAOI,qBAAqB;IACzB;;AAEJ;IACI;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;AACJ;;AAEA,2BAA2B;AAC3B;IACI;QACI,SAAS;IACb;;IAEA;QACI,6BAA6B,EAAE,iCAAiC;IACpE;AACJ;;AAEA;IACI;QACI,4BAA4B;QAC5B,2BAA2B,EAAE,iBAAiB;QAC9C,gBAAgB;QAChB,2BAA2B,EAAE,+CAA+C;IAChF;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,mBAAmB;QACnB,2BAA2B;QAC3B,UAAU;QACV,uBAAuB,EAAE,kDAAkD;IAC/E;;IAEA;QACI,uBAAuB,EAAE,+CAA+C;IAC5E;;IAEA;QACI,SAAS;QACT,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,4BAA4B;QAC5B,aAAa,EAAE,sDAAsD;QACrE,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,UAAU;QACV,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;;;QAGI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA,kCAAkC;AAClC;IACI,WAAW;IACX,iBAAiB;IACjB,yBAAyB;AAC7B;;IAEI;QACI,gBAAgB;QAChB,gBAAgB;QAChB,sBAAsB;QACtB,eAAe;QACf,gBAAgB;IACpB;;AAEJ;IACI,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;AACzC;;;AAGA;IACI;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".overviewDetailsText {\n    margin-left: 10px;\n    font-size: 1rem;\n    color: #555;\n    margin-top: 8px;\n    word-break: break-word;\n}\n\n.container {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    min-height: calc(100vh - 100px);\n    padding: 30px;\n    align-items: center;\n    justify-content: center;\n    margin: 0;\n    overflow-x: hidden;\n}\n\n.secondRow {\n    display: flex;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    flex-grow: 1;\n}\n\n.column {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 10px;\n    flex: 1;\n}\n\n.secondColumn {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 10px;\n    position: relative;\n    min-height: 100%;\n}\n\n.secondColumnContainer {\n    display: flex;\n    align-items: flex-end;\n    justify-content: center;\n    gap: 60px;\n    animation: fadeIn 0.3s ease-in-out;\n}\n\n.panelColumn {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 10px;\n    position: relative;\n    width: fit-content;\n}\n\n.resultDoubleRow {\n    flex: 0 0 500px;\n    display: flex;\n    flex-direction: column;\n    width: 500px;\n    min-width: 500px;\n}\n\n.progressRow {\n    display: flex;\n    flex-direction: column;\n    width: 500px;\n    position: relative;\n    align-items: center;\n}\n\n.resultDetails {\n    margin-top: 53px;\n    width: 500px;\n}\n\n.miniaturePanelContainer {\n    position: absolute;\n    bottom: -60px;\n    right: 0;\n    display: flex;\n    justify-content: flex-end;\n    gap: 10px;\n    padding: 10px 0;\n    z-index: 1;\n    width: 100%;\n}\n\n.extraText {\n    margin-top: 10px;\n    text-align: center;\n    padding: 0 20px;\n    width: 100%;\n}\n\n.small_adshel_image,\n.small_spectacular_portrait_image,\n.small_escalator_image,\n.small_threegroup_image {\n    height: 40px;\n    width: 20px;\n    margin: 5px;\n    cursor: pointer;\n    transition: transform 0.2s ease;\n}\n\n.small_spectacular_image,\n.small_billboard_image,\n.small_storm_image {\n    height: 20px;\n    width: 40px;\n    margin: 5px;\n    cursor: pointer;\n    transition: transform 0.2s ease;\n}\n\n    .small_adshel_image:hover,\n    .small_spectacular_portrait_image:hover,\n    .small_escalator_image:hover,\n    .small_threegroup_image:hover,\n    .small_spectacular_image:hover,\n    .small_billboard_image:hover,\n    .small_storm_image:hover {\n        transform: scale(1.1);\n    }\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n    }\n}\n\n/* Responsive Breakpoints */\n@media (max-width: 1420px) {\n    .secondColumnContainer {\n        gap: 40px;\n    }\n\n    .panelColumn {\n        max-width: calc(100% - 540px); /* 500px for Details + 40px gap */\n    }\n}\n\n@media (max-width: 1370px) {\n    .container {\n        padding: 80px 20px 20px 20px;\n        height: calc(100vh - 100px); /* Fixed height */\n        overflow-y: auto;\n        justify-content: flex-start; /* Change to flex-start since we're scrolling */\n    }\n\n    .secondColumnContainer {\n        flex-direction: column;\n        gap: 30px;\n        align-items: center;\n        justify-content: flex-start;\n        padding: 0;\n        min-height: min-content; /* Allow container to be as small as its content */\n    }\n\n    .secondColumn {\n        min-height: min-content; /* Allow column to be as small as its content */\n    }\n\n    .resultDoubleRow {\n        order: -1;\n        margin-bottom: 30px;\n    }\n\n    .panelColumn {\n        width: fit-content;\n        max-width: calc(100% - 40px);\n        margin-top: 0; /* Remove auto margin since we're controlling height */\n        margin-bottom: 60px;\n    }\n\n    .miniaturePanelContainer {\n        bottom: -60px;\n        right: 50%;\n        transform: translateX(50%);\n    }\n}\n\n@media (max-width: 600px) {\n    .container {\n        padding: 10px;\n    }\n\n    .secondColumn {\n        padding: 5px;\n    }\n\n    .resultDoubleRow,\n    .progressRow,\n    .resultDetails {\n        max-width: 100%;\n        overflow-x: auto;\n    }\n\n    .secondColumnContainer {\n        gap: 20px;\n    }\n\n    .panelColumn {\n        max-width: calc(100% - 20px);\n    }\n}\n\n/* Table styles remain unchanged */\n.table {\n    width: 100%;\n    border-spacing: 0;\n    border-collapse: collapse;\n}\n\n    .table td {\n        padding: 6px 8px;\n        text-align: left;\n        vertical-align: middle;\n        font-size: 14px;\n        line-height: 1.4;\n    }\n\n.boldText {\n    font-weight: 600;\n    min-width: 80px;\n    color: #333;\n    padding-right: 16px;\n}\n\n.table tr:hover {\n    background-color: rgba(0, 0, 0, 0.02);\n}\n\n\n@media (min-aspect-ratio: 2) {\n    .container {\n        height: calc(100vh - 70px);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overviewDetailsText": `SummaryPage-module__overviewDetailsText___ZBiDa`,
	"container": `SummaryPage-module__container___S4mpK`,
	"secondRow": `SummaryPage-module__secondRow___e7aMi`,
	"column": `SummaryPage-module__column___j6QZx`,
	"secondColumn": `SummaryPage-module__secondColumn___ovbt8`,
	"secondColumnContainer": `SummaryPage-module__secondColumnContainer___BdBpD`,
	"fadeIn": `SummaryPage-module__fadeIn___FZxnH`,
	"panelColumn": `SummaryPage-module__panelColumn___mxzrR`,
	"resultDoubleRow": `SummaryPage-module__resultDoubleRow___xILDN`,
	"progressRow": `SummaryPage-module__progressRow___TBw23`,
	"resultDetails": `SummaryPage-module__resultDetails___uQOEU`,
	"miniaturePanelContainer": `SummaryPage-module__miniaturePanelContainer___lXxPJ`,
	"extraText": `SummaryPage-module__extraText____XgcM`,
	"small_adshel_image": `SummaryPage-module__small_adshel_image___bAYlQ`,
	"small_spectacular_portrait_image": `SummaryPage-module__small_spectacular_portrait_image___NYWPh`,
	"small_escalator_image": `SummaryPage-module__small_escalator_image___H3FqB`,
	"small_threegroup_image": `SummaryPage-module__small_threegroup_image___JALWJ`,
	"small_spectacular_image": `SummaryPage-module__small_spectacular_image___n8ULD`,
	"small_billboard_image": `SummaryPage-module__small_billboard_image___q8I59`,
	"small_storm_image": `SummaryPage-module__small_storm_image___lDtpJ`,
	"table": `SummaryPage-module__table___CIbbB`,
	"boldText": `SummaryPage-module__boldText___ozG6r`
};
export default ___CSS_LOADER_EXPORT___;
